import { Link } from 'react-router-dom';
import { api } from '../api/client';
import { EmptyState, ErrorState, Loading } from '../components/states';
import { useAsync } from '../hooks/useAsync';
import { useT } from '../i18n/I18nProvider';

interface WgInterface {
  id: string;
  deviceId: string;
  name: string;
  listenPort: number;
  addresses: string[];
  mtu: number | null;
  mssClamp: number | null;
  status: string;
  lastReportAt: string | null;
}

export function WireGuardPage(): JSX.Element {
  const t = useT();
  const { data, error, loading, reload } = useAsync(
    () => api.get<WgInterface[]>('/wireguard/interfaces'),
    [],
  );

  return (
    <section>
      <div className="page-head">
        <h1>{t('wireguard.title')}</h1>
        <button
          type="button"
          className="btn btn--ghost"
          onClick={() => void api.post('/wireguard/health/evaluate').then(reload)}
        >
          {t('wireguard.evaluateHealth')}
        </button>
      </div>

      {loading ? (
        <Loading />
      ) : error ? (
        <ErrorState message={error.message} onRetry={reload} />
      ) : !data || data.length === 0 ? (
        <EmptyState hint={t('wireguard.empty')} />
      ) : (
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>{t('wireguard.interface')}</th>
                <th>{t('wireguard.listenPort')}</th>
                <th>{t('wireguard.addresses')}</th>
                <th>{t('wireguard.mtu')}</th>
                <th>{t('wireguard.status')}</th>
              </tr>
            </thead>
            <tbody>
              {data.map((iface) => (
                <tr key={iface.id}>
                  <td>
                    <Link to={`/wireguard/${iface.id}`}>{iface.name}</Link>
                  </td>
                  <td>{iface.listenPort}</td>
                  <td>{iface.addresses.join(', ')}</td>
                  <td>
                    {iface.mtu ?? '—'}
                    {iface.mssClamp ? ` / ${iface.mssClamp}` : ''}
                  </td>
                  <td>
                    <span className={`chip chip--${iface.status.toLowerCase()}`}>
                      {iface.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
